import { http } from '@pendo/http';

export function fetchPages () {
    return http.get('/api/s/_SID_/page?expand=*');
}

export function fetchPage (pageId) {
    return http.get(`/api/s/_SID_/page/${pageId}`);
}

export function fetchPageGuides (pageId) {
    return http.get(`/api/s/_SID_/page/${pageId}/guide`);
}

export async function updatePage (page, shouldStartProcessing) {
    const updatedPage = await http.put(`/api/s/_SID_/page/${page.id}`, page);

    if (shouldStartProcessing) {
        try {
            await startProcessingPage(page.id);
        } catch (error) {
            const reverseProcessingJobIsAlreadyRunning = error.response.status === 409;
            if (!reverseProcessingJobIsAlreadyRunning) {
                throw error;
            }
        }
    }

    return updatedPage;
}

export function patchPage (pageId, patch) {
    return http.patch(`/api/s/_SID_/page/${pageId}`, { patch });
}

export async function createPage (newPage, shouldStartProcessing = true) {
    const savedPage = await http.post('/api/s/_SID_/page', newPage);
    if (shouldStartProcessing) {
        try {
            await startProcessingPage(savedPage.data.id);
        } catch (error) {
            // 409 just means the tagging job is queued for later
            if (error.response.status !== 409) {
                throw error;
            }
        }
    }

    return savedPage;
}

export function deletePage ({ id }) {
    return http.delete(`/api/s/_SID_/page/${id}`);
}

// The empty `{}` is required for the "apply" calls. The BE requires a content-type header but
// axios strips it if the body is undefined. It's been reported as bug but closed as `Wont Fix`
// https://github.com/axios/axios/issues/1535
export function startProcessingPage (pageId) {
    return http.post(`/api/s/_SID_/page/${pageId}/apply`, {});
}
